import React from 'react';
import { Cross } from '@icons/common';
import './Tag.scss';
import classNames from 'classnames';

interface TagProps {
  label: string;
  variant?: 'secondary' | 'primary';
  onCloseClick?: () => void;
}

export const Tag = ({ label, onCloseClick, variant = 'secondary' }: TagProps) => {
  return (
    <div className={classNames('c-tag', `c-tag-${variant}`)}>
      <p className='c-tag__label'>{label}</p>
      <button className='c-tag__close' onClick={onCloseClick}>
        <Cross />
      </button>
    </div>
  );
};
